export default {
  namespaced: true,
  log_incident: {
    title: "registro incidente | registros de incidentes",
    comment: "comentario",
  },
};
